import type { LoyaltyReward } from '../types';

export const initialRewards: LoyaltyReward[] = [
    { id: 1, name: 'Free Coffee', pointsRequired: 100, discountValue: 5.50 },
    { id: 2, name: '$5 Off Voucher', pointsRequired: 250, discountValue: 5.00 },
    { id: 3, name: '$10 Off Voucher', pointsRequired: 500, discountValue: 10.00 },
];